<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存操作历史</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
      <el-col :span="4">
          <el-input placeholder="请输入商品名称" v-model="queryInfo.name" clearable @clear="getGoodsList">
          </el-input>
      </el-col>
        <el-col :span="7">
          <el-input placeholder="请输入商品编码" v-model="queryInfo.query" clearable @clear="getGoodsList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker v-model="queryInfo.time" @change="timechange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&tid=' + queryInfo.tid">
            <!-- <a class="aaaa" :href="exportUrl + '&time=' + queryInfo.time?queryInfo.time.toString():null + '&tid=' + queryInfo.tid"> -->
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- table表格区域 -->
      <el-table :data="goodslist" border stripe @filter-change="handleFilterChange" @selection-change="handleSelectionChange">
        <el-table-column fixed type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品名称" prop="goodtitle" width="120px"></el-table-column>
        <el-table-column label="商品编码" prop="number" width="120px"></el-table-column>
        <el-table-column :label="typeTxt" align="center" :filter-multiple="false" :column-key="'type'" :filters="filterStatus" prop="tip" width="100px"> </el-table-column>

        <!-- <el-table-column label="增加/减少" align="center" prop="tip" width="100px"></el-table-column> -->
        <el-table-column label="操作人" align="center" prop="lastman" width="140px"></el-table-column>
        <el-table-column label="操作时间" align="center" prop="lasttime" width="160px"></el-table-column>
        <el-table-column label="修改数量" prop="changekucun" align="center"> </el-table-column> --> <el-table-column label="备注" prop="beizhu" align="center"> </el-table-column> -->
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      exportUrl: 'https://hsapi.sqmilk.com/exportKucunLogList?mPhone=' + localStorage.getItem('phone'),
      // 查询参数对象
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
        time: null,
        tid: 0
      },

      typeTxt: "减少/增加",
      filterStatus: [
        { text: '减少', value: 1 },
        { text: '增加', value: 2 }],

      changeKucunForm: {
        id: null,
        kucun: null,
        changekun: null,
        changeBeizhu: null,
        addtip: 'add',
      },
      changeKucunVisible: false,
      changeKucunFormRules: {
        changekun: [
          { required: true, message: '请输入要修改的库存数', trigger: 'blur' }
        ],
        changeBeizhu: [
          { required: true, message: '请填写修改备注信息', trigger: 'blur' }
        ]
      },
      // 商品列表
      goodslist: [],
      // 总数据条数
      total: 0,
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },


  created () {
    this.getGoodsList()
  },

  methods: {

    handleFilterChange (filters) {
      console.log(filters);
      if (filters.type.length > 0) {
        this.queryInfo.tid = filters.type[0]
        if (this.queryInfo.tid == 1) {
          this.typeTxt = "减少"
        } else if (this.queryInfo.tid == 2) {
          this.typeTxt = "增加"
        } else {
          this.typeTxt = "减少/增加"
        }
      } else {
        this.queryInfo.tid = 0;
        this.typeTxt = "减少/增加"
        console.log(this.queryInfo);
      }
      this.getGoodsList(); // 通过接口获取数据的方法
    },

    timechange (e) {
      this.filterSelect();
    },

    search () {
      this.total = 0
      this.goodslist = []
      this.getGoodsList()
    },

    filterSelect () {
      this.total = 0
      this.goodslist = []
      this.getGoodsList()
    },

    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = [];
      val.forEach(element => {
        this.multipleSelection.push({ 'id': element.id });
      });
      if (this.multipleSelection) {
        this.multipleSelectionjson = JSON.stringify(this.multipleSelection);
        this.exportUrl = 'https://hsapi.sqmilk.com/exportKucunLogList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.sqmilk.com/exportKucunLogList?mPhone=' + localStorage.getItem('phone')
      }
    },

    // 根据分页获取对应的商品列表
    async getGoodsList () {
      const { data: res } = await this.$http.get('admin/good/KucunListLogs', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      this.$message.success('获取列表成功！')
      console.log(res.result)
      this.goodslist = res.result.list
      this.total = res.result.count
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getGoodsList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getGoodsList()
    },

    async removeById (id) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该商品, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }

      const { data: res } = await this.$http.delete(`goods/${id}`)

      if (res.meta.status !== 200) {
        return this.$message.error('删除失败！')
      }

      this.$message.success('删除成功！')
      this.getGoodsList()
    },
    // 监听 switch 开关状态的改变
    async goodStateChanged (userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/good/updateStatus', {
        status: userinfo.status,
        id: userinfo.id
      })
      if (res.code !== 200) {
        userinfo.mg_state = !userinfo.mg_state
        return this.$message.error('更新商品状态失败！')
      }
      this.$message.success('更新商品状态成功！')
    },

    goAddpage () {
      this.$router.push('/goods/add')
    },
    // 操作记录
    editHistory () {
      this.$router.push('/kucun/editHistory')
    },

    // 低温商品截止时间设置
    goToSetEndTime () {
      this.$router.push('/goods/dwGoodEndTime')
    },

    // 编辑
    editById (row) {
      console.log(row);
      this.changeKucunForm.id = row.id;
      this.changeKucunForm.kucun = row.kucun;
      this.changeKucunVisible = true;
      // this.$router.push({ path: '/goods/add', query: { id: id } })

    },
    // 修改库存请求
    async sureChangeKucun () {
      var phone = window.sessionStorage.getItem('phone')

      const { data: res } = await this.$http.post('/admin/good/changeKucun', {
        changeBeizhu: this.changeKucunForm.changeBeizhu,
        addtip: this.changeKucunForm.addtip,
        kucun: this.changeKucunForm.kucun,
        changekucun: this.changeKucunForm.changekun,
        id: this.changeKucunForm.id,
        phone: phone,
      })
      if (res.code !== 200) {
        return this.$message.error('更新商品库存失败！')
      }
      this.$message.success('更新商品库存成功！')
      this.changeKucunVisible = false
      this.getGoodsList();
    },

    changeKucunDialogClosed () {
      this.changeKucunVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
